import _ from 'lodash';
import { getSales } from '../../apis/backend';
import { ERROR_UPDATE_STOCK, ERROR_GET_SALES } from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import apiService from '@dishopsaas/dishop-backend-api-service'

export const handleCheckBox = (component, checked) => {
  component.setState({ ...component.state, checked });
};
export const handleClick = (
  { vente, name, stockRestant, productId, sectionId, revenue },
  component
) => {
  component.setState({
    modalOpen: true,
    name,
    vente,
    stockRestant,
    productId,
    sectionId,
    revenue,
    checked: !Number.isInteger(parseInt(stockRestant, 10))
  });
};

export const handleClose = component => {
  component.setState({ modalOpen: false });
};

export const handleChange = ({ target }, component) =>
  component.setState({ [target.id]: parseInt(target.value, 10), checked: false });

export const handleSubmit = async component => {
  const { productId, sectionId, checked } = component.state;
  const { openErrorModal, shopId } = component.props;
  let { stockRestant } = component.state;
  if (!checked) {
    stockRestant = stockRestant > 0 ? stockRestant : 0;
  } else {
    stockRestant = null;
  }
  try {
    await apiService.menusUpsert(
      [shopId, 'sections', sectionId, 'products'], // don't accept path longer than 4 items
      { [productId]: { stock: stockRestant } }
    )
  } catch (err) {
    openErrorModal(ERROR_UPDATE_STOCK);
    sendCloudWatchAlert(`Error when updating stock ${err}`);
  }
  component.setState({ modalOpen: false });
};

export const initStock = async (props, component, disableLoading) => {
  const { menu, shopId, openErrorModal } = props;
  try {
    !disableLoading &&
      component.setState({
        isLoading: true,
        stock: []
      });
    const { dateRange } = component.state;
    const startAt = dateRange.startDate;
    const endAt = dateRange.endDate;
    const sales = (await getSales(shopId, startAt, endAt)) || {};
    const productStock = {};
    if (menu.sections) {
      _.map(menu.sections, (section, sectionId) => {
        const { products = {}, key: sectionKey } = section;
        _.map(products, (product, productId) => {
          const { name = '', stock, key: productKey } = product;
          const productRef = `${sectionKey}@${productKey}`;
          let sold = 0;
          let price = 0;
          _.map(sales, sale => {
            const saleProduct = _.find(sale.products, product => {
              return product.productRef === productRef;
            });
            if (saleProduct) {
              sold += saleProduct.nb;
              price += saleProduct.revenue;
            }
          });
          productStock[productKey] = {
            productId,
            sectionId,
            sold,
            price,
            name,
            stock
          };
        });
      });
      component.setState({
        stock: _.sortBy(productStock, ['price']).reverse(),
        isLoading: false
      });
    }
  } catch (error) {
    sendCloudWatchAlert(`Error when initiating stock ${error}`);
    openErrorModal(ERROR_GET_SALES);
    component.setState({
      isLoading: false,
      stock: []
    });
  }
};

export const onSelectDate = async (component, dateRange) => {
  await component.setState({
    dateRange,
    isLoading: true,
    stock: []
  });
  initStock(component.props, component);
};
